export default __webpack_public_path__ + "static/media/ShMunAnimatedGif-inside.6ce7dde5.gif";